import React, { useEffect, useState } from "react"
import Fuse from "fuse.js"

const SearchFuzzy = ({
  handleSelectArea,
  areasSuggestionList = [],
  placeholder,
  setSearchText,
  searchText,
  setSearchSlug,
}) => {
  const [suggestions, setSuggestions] = useState([])
  const [showDropdown, setShowDropdown] = useState(false)

  const onSuggestionSelected = (suggestion) => {
    handleSelectArea(suggestion)
  }

  const handleSearch = (val) => {
    setSearchText(val)
    setSearchSlug("", false)

    if (val === "") return setShowDropdown(false) 
      setSuggestions(areasSuggestionList)

      const fuse = new Fuse(areasSuggestionList, {
        keys: ["name", "slug"],
        threshold: 0.2, // Lower threshold for higher accuracy
        distance: 100, // Distance for fuzzy matching
        minMatchCharLength: 1, // Minimum characters to match
        ignoreLocation: true, // Match anywhere in the string
        useExtendedSearch: true, // Use more accurate search
      });
    
      const results = fuse.search(val);
    
      // Sort by relevance (score) and then by level, assuming level is a number
      const sortedResults = results
        .map((result) => result.item)
        .sort((a, b) => {
          // First, sort by the search relevance score (lower score is better)
          const scoreA = results.find((result) => result.item === a)?.score || 0;
          const scoreB = results.find((result) => result.item === b)?.score || 0;
    
          if (scoreA !== scoreB) return scoreA - scoreB;
    
          // If scores are the same, then sort by level (assuming level is a number)
          return (a.level || 0) - (b.level || 0);
        });
    
      setShowDropdown(true);
      return setSuggestions(sortedResults);
  }

  // show the dropdown if the focus is on the input field
  useEffect(() => {
    const input = document.getElementById("search-input-field")
    const listener = (event) => {
      if (input?.contains(event.target)) {
        setShowDropdown(true)
      } else {
        setShowDropdown(false)
      }
    }

    window.addEventListener("click", listener)

    return () => {
      window.removeEventListener("click", listener)
    }
  }, [])

  return (
    <div className="autosuggest__container">
      <input
        id="search-input-field"
        type="text"
        placeholder={placeholder}
        className="autosuggest__input"
        value={searchText}
        onChange={(e) => handleSearch(e.target.value)}
        autocomplete="off"
      />
      {showDropdown && suggestions?.length > 0 &&(
        <div className="autosuggest__suggestions-container">
          <div className="autosuggest__suggestions-list">
            {suggestions.map((suggestion) => (
              <div
                key={suggestion.slug}
                className="autosuggest__suggestion"
                onClick={() => {
                  onSuggestionSelected(suggestion)
                  setShowDropdown(false)

                  const input = document.getElementById("search-input-field")
                  input?.focus()
                }}
              >
                {suggestion.name}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default SearchFuzzy
